function setColorVariables(colors) {
  const root = document.documentElement;

  root.style.setProperty('--primary', colors.primary.main);
  root.style.setProperty('--primary-light', colors.primary.light);
  root.style.setProperty('--primary-dark', colors.primary.dark);
  root.style.setProperty('--primary-darker', colors.primary.darker);
  root.style.setProperty('--text-accent', colors.text.accent);

  root.style.setProperty('--red', colors.colorShades.red);
  root.style.setProperty('--pureWhite', colors.colorShades.pureWhite);
  root.style.setProperty('--black', colors.colorShades.black);
  root.style.setProperty('--blue', colors.colorShades.blue);
  root.style.setProperty('--grey', colors.colorShades.lightGrey);
  root.style.setProperty('--lightgrey', colors.colorShades.veryLightGrey);
  root.style.setProperty('--darkgrey', colors.colorShades.greyShade);
  root.style.setProperty('--lightblue', colors.colorShades.lightBlue);
}

export default setColorVariables;
